// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import dayjs from 'dayjs'
import BaiduMap from 'vue-baidu-map'

Vue.config.productionTip = false

// 定义全局时间戳过滤器
Vue.filter('formatDate', function (value, fmt = 'YYYY-MM-DD HH:mm:ss') {
  if (value === '' || value === undefined) {
    return '-'
  }
  console.log(value)
  console.log(value.length)
  if (value.length === 10) {
    value = parseInt(value) * 1000
  }
  return dayjs(parseInt(value)).format(fmt)
})
Vue.use(BaiduMap, {
  ak: 'Glvz6nqUCSK65DNLlLqBQYkAVdRLV5T6' // 百度地图秘钥
})
Vue.use(ElementUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  axios,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js